import { render } from "./VentasPage.vue?vue&type=template&id=8c9f8332"
import script from "./VentasPage.vue?vue&type=script&lang=js"
export * from "./VentasPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__